<template>
  <h1 class="system_content_title">往年评价记录</h1>
  <div class="system_content_panels">
    <div class="systemPanel" style="position: relative; padding-bottom: 40px">
      <el-form-item>
        <el-input clearable v-model="state.searchInput" style="width: 220px; margin-right: 6px"
          placeholder="输入企业名称搜索"></el-input>


        <el-button type="primary" @click="getTableData">搜索</el-button>
      </el-form-item>

      <el-table :data="state.tableData" stripe v-loading="state.loading" style="min-height: 70vh" table-layout="fixed">
        <el-table-column type="index" label="序号" width="55">
        </el-table-column>
        <el-table-column prop="title" label="年度" sortable>
          <template #default="scope">
            <span>{{ scope.row.title.slice(0, 4) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="companyName" label="企业名称" sortable>
          <template #default="scope">
            <span v-html="scope.row.companyName"></span>
          </template>
        </el-table-column>
        <el-table-column prop="flowStepname" label="当前评审流程" sortable width="140">
        </el-table-column>
        <el-table-column prop="score1" label="自评分数" sortable>
        </el-table-column>
        <el-table-column prop="scorelevel1" label="自评结果">
          <template #default="scope">
            {{ scope.row.scorelevel1.slice(0, 4) }}
          </template>
        </el-table-column>
        <el-table-column prop="scorelevel1" label="自评等级">
          <template #default="scope">
            {{ replaceChinese(scope.row.scorelevel1) }}
          </template>
        </el-table-column>
        <el-table-column prop="score2" label="当前审核分数" sortable></el-table-column>
        <el-table-column prop="scorelevel2" label="当前审核结果">
          <template #default="scope">
            <p v-if="scope.row.scorelevel2 == '未填报' || scope.row.score2 == 0"></p>
            <p v-else-if="scope.row.score2 > 100">无效分数</p>
            <p v-else>{{ scope.row.scorelevel2.slice(0, 4) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="scorelevel2" label="当前审核等级">
          <template #default="scope">
            <p v-if="scope.row.scorelevel2 == '未填报' || scope.row.score2 == 0"></p>
            <p v-else-if="scope.row.score2 > 100">无效分数</p>
            <p v-else>{{ replaceChinese(scope.row.scorelevel2) }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="regionFullName" label="行政区划" sortable width="160">
        </el-table-column>

        <el-table-column label="操作">
          <template #default="scope">

            <el-button size="small" type="warning" @click="showDetail(scope.row.id)"
              style="margin-bottom: 2px; margin-right: 2px">查看填报单</el-button>
            <br>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="state.pageInfo.pageIndex" :page-sizes="[20, 50, 100, 200, 500, 1000]"
        :page-size="state.pageInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="state.pageInfo.totalRowCount" v-if="state.pageInfo.totalRowCount" class="pageinfo">
      </el-pagination>
    </div>

  </div>
</template>

<script>
import { onMounted, reactive } from "vue-demi";
import api from "../../http/apis";
import { ElMessageBox, ElMessage, ElNotification } from "element-plus";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { DArrowLeft } from "@element-plus/icons-vue";
import CONSTS from "../../store/consts";
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const BASE_URL = CONSTS.BASE_URL;
    // if (!route.query.taskID) {
    //   ElMessage({
    //     message: "没有该工作任务，将返回到列表",
    //     type: "error",
    //   });

    //   setTimeout(() => {
    //     router.push("/system/review/reviewTasksListCompany ");
    //   }, 3000);
    // }

    const state = reactive({
      tableData: [],
      taskList: [],
      taskSelect: "",
      loading: false,
      searchInput: "",
      pageInfo: {},
      addVisible: false,
      addSearch: "",
      addSearchLoading: false,
      audItemList: [],
      audID: null,
      audName: null,
      appealText: null,
      appealFile: null,
      companySearchInput: "",
      appealItem: null,
      editItem: null,
      statusSelect: 1,
      detailVisible: false,
      detailObj: null
    });

    const getTableData = async () => {
      state.loading = true;
      const { data } = await api.auditionApi.getZYJReviewListAd({
        page: state.pageInfo.pageIndex || 1,
        rows: state.pageInfo.pageSize || 20,
        sort: "",
        value: state.searchInput,

      });
      if (data.isSuccessful) {
        state.loading = false;
        state.tableData = data.resultObj.data;
        state.pageInfo = data.resultObj.pagerInfo;
      } else if (data.resultMsg) {
        ElMessage({
          message: data.resultMsg,
          type: "error",
        });
      } else {
        ElMessage({});
      }
    };

    getTableData()

    const handleChange = (index) => {
      // 下拉选择框
      state.audID = state.audItemList[index].id;
      state.audName = state.audItemList[index].name;
    };
    const showAdd = () => {
      state.addVisible = true;
    };


    const uploadHandler = async (param) => {
      const file = param.file;
      console.info("file", param.file.type);
      let formData = new FormData();
      formData.append("file", file);
      const fileName = file.name.substring(0, file.name.lastIndexOf("."))
      const { data } = await api.reviewTaskApi.saveFile({
        uappcomid: state.taskID,
        seqnum: "appeal",
        formData,
        fileName,
        file,
      });
      if (data.isSuccessful) {
        const fileUrl = data.resultObj[0];
        state.appealFile = fileUrl;
        ElMessage({
          message: "上传成功",
          type: "success",
        });
      } else {
        if (data.resultMsg) {
          ElMessage({
            message: data.resultMsg,
            type: "error",
          });
        } else {
          ElMessage({
            message: "未知错误，请联系管理员",
            type: "error",
          });
        }
      }
    };
    const getFileName = (val) => {
      if (val != null) {
        if (val || val != "") {
          console.info("fileurl", val);
          const fileUrl = val.split("/");
          const fileName = fileUrl.pop();
          return fileName;
        } else {
          const str = "无";
          return str;
        }
      }
    };


    const handleClose = () => {
      state.taskID = null;
      state.audID = null;
      state.audName = null;
      state.appealText = null;
      state.appealFile = null;
      state.editItem = null;
      state.addVisible = false;
      state.appealItem = null;
    };

    const showDetail = async (id) => {
      // const {data}=await api.reviewTaskApi.getReviewFormByID(id)
      // console.info("get review form",data)

      const path = `/system/audition/zyjReviewDetail?unitAID=${id}`;
      const routerData = router.resolve(path);
      window.open(routerData.href, "_blank");
      // const { data } = await api.auditionApi.getZYJReviewDetail(id)
      // console.info("got detail,", data)
      // if (data.isSuccessful) {
      //   state.detailObj = data.resultObj
      // }
      // return;
    };
    const replaceChinese = (str) => {
      const newStr = str.replace(/[\u4e00-\u9fa5]/g, "");
      return newStr || str;
    }
    return {
      state,
      getTableData,
      handleClose,
      showDetail,
      showAdd,
      handleChange,
      uploadHandler,
      getFileName,
      replaceChinese
    };
  },
  methods: {
    handleSizeChange(val) {
      this.state.pageInfo.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.state.pageInfo.pageIndex = val;
      this.getTableData();
    },
    getBack() {
      window.history.go(-1);
    },
  },
};
</script>

<style scoped lang='scss'>
@use "../../assets/scss/table.scss" as *;

.el-input__inner {
  width: 100%;
}
</style>
